module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<form> <input type=\"hidden\" name=\"token\"> <p> <a alt=\"Add Credit Card\" class=\"add_card btn btn-clear btn-block\" href=\"#\"> <span class=\"fa fa-credit-card credit-card\"></span> Add Credit Card </a> </p> </form> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/billing/payment_methods/credit_card_button/template.ejs
// module id = 1139
// module chunks = 1